import { fabric } from 'fabric'
import imageProxy from '@/libs/image-proxy'

const maxImageDimension = 2000
const imageQuality = 75

const placeHolderColour = '#DDDDDD'
const placeHolderBG = '#F9F9F9'

// override the default render method to fix an issue with IE/Edge
fabric.Image.prototype._render = function (ctx) {
  const x = -this.width / 2
  const y = -this.height / 2
  let elementToDraw = null

  if (this.isMoving === false && this.resizeFilter && this._needsResize()) {
    this._lastScaleX = this.scaleX
    this._lastScaleY = this.scaleY
    this.applyResizeFilters()
  }

  elementToDraw = this._element
  elementToDraw && ctx.drawImage(elementToDraw, x, y, this.width, this.height)

  this._stroke(ctx)
  this._renderStroke(ctx)
}

if (!fabric.Image._fromObject) {
  fabric.Image._fromObject = fabric.Image.fromObject
  fabric.Image.fromObject = function (object, callback) {
    if (fabric.Image._fromObjectMode === 2) {
      return fabric.Image._fromObjectV2(object, callback)
    }

    return fabric.Image._fromObjectV1(object, callback)
  }
}

let pending = 0
const failed = []

fabric.Image._fromObjectV2 = function (object, callback) {
  scaleImage(object)
  proxyImage(object)
  pending++
  const pendingCallback = (image, error) => {
    pending--
    if (error) {
      if (object.key) {
        failed.push({ width: object.width, height: object.height, top: object.top, left: object.left, scaleX: object.scaleX, scaleY: object.scaleY })
      }
    }
    return callback(image, error)
  }
  return fabric.Image._fromObject(object, pendingCallback)
}

const scaleImage = function (image) {
  if (image.width > maxImageDimension || image.height > maxImageDimension) {
    if (image.width >= image.height) {
      image.scaleX = image.scaleX * (image.width / maxImageDimension)
      image.scaleY = image.scaleY * (image.width / maxImageDimension)
      image.height = Math.round(maxImageDimension * (image.height / image.width))
      image.width = maxImageDimension
    } else {
      image.scaleX = image.scaleX * (image.height / maxImageDimension)
      image.scaleY = image.scaleY * (image.height / maxImageDimension)
      image.width = Math.round(maxImageDimension * (image.width / image.height))
      image.height = maxImageDimension
    }
  }
}

const proxyImage = function (image) {
  image.src = imageProxy.proxy(image.src, { width: image.width, height: image.height, quality: imageQuality })
  image.crossOrigin = 'anonymous'
}

export default {
  isA: function (object) {
    return object.type === 'image'
  },
  new: function (url, canvasWidth, canvasHeight, callback) {
    // need to pre-proxy the image which will account for any exif rotation issues
    url = imageProxy.proxy(url, { quality: imageQuality })
    return fabric.Image.fromURL(url, (image) => {
      const padding = 0

      scaleImage(image)
      proxyImage(image)

      const widthScale = (canvasWidth - padding) / image.width
      const heightScale = (canvasHeight - padding) / image.height

      if (widthScale < 1 || heightScale < 1) {
        let scale = widthScale
        if (widthScale > heightScale) {
          scale = heightScale
          image.scale(scale)
          image.center()
        }
      }

      callback(image)
    }, {
      crossOrigin: 'anonymous'
    })
  },
  pending: function () {
    return pending > 0
  },
  failed: function () {
    return failed.length > 0
  },
  popFailed: function () {
    const temp = []
    const len = failed.length
    for (let i = 0; i < len; i++) {
      temp.push(failed.shift())
    }
    return temp
  },
  newPlaceHolder: function (config) {
    const text = new fabric.Text('\uf03e', {
      fill: placeHolderColour,
      fontSize: 50,
      fontFamily: 'FontAwesome'
    })

    if (!config) {
      return text
    }

    const box = new fabric.Rect({
      left: 0,
      width: config.width,
      height: config.height,
      strokeWidth: 3,
      stroke: placeHolderColour,
      fill: placeHolderBG
    })

    const group = new fabric.Group([box], config)
    text.set({
      originX: 'center',
      originY: 'center'
    })
    group.add(text)

    return group
  },
  getDetails: function (image) {
    return {
      url: image.src,
      image: image.src,
      name: 'View Image'
    }
  }
}
